import { Attr, BelongsTo, HasMany, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Organisation from "./Organisation";
import type OrganisationFeatureAllowance from "./OrganisationFeatureAllowance";
import type Version from "./Version";

@Model()
class OrganisationsFeature extends ApplicationRecord {
  static jsonapiType = "organisations_features";

  @Attr({ persist: false }) accessLevel: string;

  @Attr({ persist: false }) billable: boolean;

  @Attr() cost: number;

  @Attr({ persist: false }) description: string;

  @Attr() enabled: boolean;

  @Attr() feature: string;

  @Attr({ persist: false }) flaggable: boolean;

  @Attr({ persist: false }) label: string;

  @Attr({ persist: false }) locked: boolean;

  @Attr({ persist: false }) monthlyCredits: number;

  @Attr({ persist: false }) name: string;

  @BelongsTo() organisation: Organisation;

  @HasMany()
  organisationFeatureAllowances: OrganisationFeatureAllowance[];

  @Attr() organisationId: number;

  @Attr({ persist: false }) parentFeatureId: number;

  @Attr({ persist: false }) position: number;

  @Attr({ persist: false }) tag: string;

  @HasMany() versions: Version[];
}

export default OrganisationsFeature;
